import React, { Component } from "react";
import { connect } from "react-redux";

import { Grid, Typography, TextField, Button } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import MenuItem from "@material-ui/core/MenuItem";

import UpdateRMAvailability from "./UpdateRMAvailability";

import { cmoFetchRMAvailability } from "../../../../../containers/actions/cmo/addRmPmActions";

class ViewAddedRM extends Component {
  state = {
    data: [],
    rmAvailabilityDetails: {
      rawMaterialName: "",
      units: "",
      requiredQuantity: "",
      shortage: "",
      mfgDate: "",
      shipmentDate: "",
      statusCode: "",
      expectedDelivery: ""
    },
    errors: {
      rawMaterialName: "",
      units: "",
      requiredQuantity: "",
      shortage: "",
      statusCode: "",
      expectedDelivery: ""
    }
  };

  componentDidMount() {
    let data = {
      ...this.props.params,
      collabType: "CMO"
    };
    this.props.cmoFetchRMAvailability(data);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.rmAvailable) {
      this.setState({ data: nextProps.rmAvailable });
    }
  }
  handleChange = e => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      rmAvailabilityDetails: {
        ...prevState.rmAvailabilityDetails,
        [name]: value
      },
      errors: {
        rawMaterialName: "",
        units: "",
        requiredQuantity: "",
        shortage: "",
        statusCode: "",
        expectedDelivery: ""
      }
    }));
  };

  validate = () => {
    let isError = false;

    let { rmAvailabilityDetails } = this.state;

    let errors = {
      rawMaterialName: "",
      units: "",
      requiredQuantity: "",
      shortage: "",

      statusCode: "",
      expectedDelivery: ""
    };

    if (rmAvailabilityDetails.rawMaterialName === "") {
      isError = true;
      errors.rawMaterialName = "Please Enter Material Name";
    } else if (rmAvailabilityDetails.units === "") {
      isError = true;
      errors.units = "Please Enter Units";
    } else if (rmAvailabilityDetails.requiredQuantity === "") {
      isError = true;
      errors.requiredQuantity = "Please Enter Required Quantity";
    } else if (rmAvailabilityDetails.shortage === "") {
      isError = true;
      errors.shortage = "Please Enter Shortage Quantity";
    } else if (rmAvailabilityDetails.statusCode === "") {
      isError = true;
      errors.statusCode = "Please Select Status";
    } else if (rmAvailabilityDetails.expectedDelivery === "") {
      isError = true;
      errors.expectedDelivery = "Please Select Expected Delivery date";
    } else {
      this.setState({ alltrue: true });
    }
    this.setState({ errors });
    return isError;
  };

  onSubmit = () => {
    let error = this.validate();
    if (!error) {
      this.setState({ disableSaveButton: true });
    }
  };
  updateRM = (ele, index) => {
    this.setState({
      rmAvailabilityDetails: ele,
      editIndex: index
    });
  };
  closeUpdate = () => {
    this.setState({
      rmAvailabilityDetails: {},
      editIndex: -1
    });
  };
  render() {
    const { data } = this.state;
    let rmAvailable = null;
    if (data.length > 0) {
      rmAvailable = data.map((ele, i) => {
        const currentlyEditing = this.state.editIndex === i;
        return (
          <React.Fragment key={i}>
            {currentlyEditing ? (
              <UpdateRMAvailability
                rmAvailabilityDetails={this.state.rmAvailabilityDetails}
                closeUpdate={this.closeUpdate}
                params={this.props.params}
              />
            ) : (
              <Grid container key={i} spacing={1}>
                <Grid item xs={12} md={2}>
                  <TextField
                    label="Name"
                    name="rawMaterialName"
                    disabled
                    fullWidth
                    value={ele.rawMaterialName}
                    // onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    label="Batch Size"
                    name="units"
                    disabled
                    fullWidth
                    value={ele.units}
                    // onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    label="Required Quantity"
                    name="requiredQuantity"
                    fullWidth
                    value={ele.requiredQuantity}
                    // onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                    style={{
                      color: "#000000"
                    }}
                    error={
                      this.state.errors.requiredQuantity === "" ? false : true
                    }
                    helperText={this.state.errors.requiredQuantity}
                  />
                </Grid>

                <Grid item xs={12} md={1}>
                  <TextField
                    label="Shortage"
                    name="shortage"
                    fullWidth
                    value={ele.shortage}
                    onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                    error={this.state.errors.shortage === "" ? false : true}
                    helperText={this.state.errors.shortage}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    label="Status"
                    select
                    fullWidth
                    name="statusCode"
                    value={ele.statusCode}
                    // onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                  >
                    <MenuItem value={ele.statusCode}>{ele.statusText}</MenuItem>
                    {/* <MenuItem value="open">Open</MenuItem>
              <MenuItem value="Acknowledge">Acknowledge</MenuItem> */}
                  </TextField>
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    label={
                      <Typography
                        variant="caption"
                        style={{ fontSize: "0.65rem" }}
                      >
                        Expected Days for Delivery
                      </Typography>
                    }
                    select
                    fullWidth
                    name="expectedDelivery"
                    value={ele.expectedDelivery}
                    onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                    error={
                      this.state.errors.expectedDelivery === "" ? false : true
                    }
                    helperText={this.state.errors.expectedDelivery}
                  >
                    <MenuItem value={ele.expectedDelivery}>
                      {ele.expectedDelivery}
                    </MenuItem>
                    {/* <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem> */}
                  </TextField>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={1}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.updateRM(ele, i)}
                  >
                    Update
                  </Button>
                </Grid>
              </Grid>
            )}
          </React.Fragment>
        );
      });
    } else {
      rmAvailable = (
        <Grid container style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={12} md={8} style={{ textAlign: "center" }}>
            <Typography variant="h6">No Records Available.</Typography>
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid item xs={12} sm={12}>
        <Card
          style={{
            margin: "0 2rem 0 2rem"
          }}
        >
          <CardContent>{rmAvailable}</CardContent>
        </Card>
        <Grid
          item
          xs={12}
          md={12}
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
            marginBottom: "1rem",
            alignItems: "center"
          }}
        >
          <Button
            variant="contained"
            // color="primary"
            style={{
              color: "#ffffff",
              backgroundColor: "green"
            }}
            onClick={this.props.toggleRMAvailabilityScreen}
          >
            {/* Save All Changes */}
            Back to Line Item
          </Button>

          {/* <Typography
            variant="body1"
            onClick={this.props.toggleRMAvailabilityScreen}
            style={{
              paddingLeft: "1rem",
              cursor: "pointer"
            }}
          >
            Cancel X
          </Typography> */}
        </Grid>
      </Grid>
    );
  }
}
const mapStatetoProps = state => ({
  rmAvailable: state.pcmp.cmo.rmpm.rmAvailable
});
export default connect(mapStatetoProps, { cmoFetchRMAvailability })(
  ViewAddedRM
);
